/* eslint-disable import/no-anonymous-default-export */
export default {
    baseurl: `http://api.searchable.dev-iuh.xyz/api`,
}